import { Component } from '@angular/core';
import { OptionsComponent } from '../../components/options/options';
import { PopoverController } from 'ionic-angular';

@Component({
    selector: 'page-compras',
    templateUrl: 'compras.html',
})
export class ComprasPage {
    public analytic: boolean = true;

    constructor(private _popoverCtrl: PopoverController) { }

    public showOptions(ev: any): void {
        let reactions = this._popoverCtrl.create(OptionsComponent, { analytic: this.analytic });

        reactions.onWillDismiss(analytic => {
            if (analytic != null)
                this.analytic = analytic;
        });

        reactions.present({ ev: ev });
    }
}


// WEBPACK FOOTER //
// ./src/pages/compras/compras.ts